import { render } from "./ScriptInfoPane.vue?vue&type=template&id=f818bdfe"
import script from "./ScriptInfoPane.vue?vue&type=script&lang=js"
export * from "./ScriptInfoPane.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__